module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w3-container contact-container"
  }, [_c('h1', {
    staticClass: "w3-xxxlarge"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('Contact')))])]), _vm._v(" "), _c('hr', {
    staticClass: "w3-round"
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('Contact us text'))
    }
  }), _vm._v(" "), _c('iframe', {
    staticClass: "google-maps",
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2742.284948698673!2d20.679353634592207!3d46.58160401237761!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47443c2961aae753%3A0x458fc61ebcfac3d3!2sOrosh%C3%A1za%2C%20Juh%C3%A1sz%20Gyula%20u.%2020%2C%205900%20Hungary!5e0!3m2!1sen!2sus!4v1677170241840!5m2!1sen!2sus",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3dd26f4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactContent.vue
// module id = 956
// module chunks = 0